module.exports = __webpack_public_path__ + "0af8c1250eabb4bd53607fb0a4da0868.MP3";